/* eslint-disable sort-keys */
export default {
    Form: {
        parts: [
            "control", "label", "errorMessage", "helperText",
        ],
        baseStyle: {
            control: {
                borderStyle: "sm",
                borderTopColor: "secondary.50",
                borderRadius: "5"
            },
            label: {
                m: "none",
                h: 3,
            },
        },
        sizes: {
            default: {}
        },
        variants: {
            solid: {
                control: {
                    borderStyle: "solid"
                }
            },
        },
        defaultProps: {
            variant: "solid",
        },
    }
};

